import * as Sentry from '@sentry/browser';
import { getArticleId } from '@utils/article';

/*
  ARTICLE DETAIL FEATURE MODULES | samostatné funkční celky

  To stejné co features.ts, ale pro detail článku (kvůli granularitě kódu).
*/

// LISTOVAČKA | Ovládání UI pro listovací články
export const articleListed = async () => {
  const wrapper: HTMLDivElement | null = document.querySelector('[data-article-listed]');

  if (wrapper) {
    const ArticleListed = await import(
      /* webpackChunkName: 'default/chunk-article-listed' */
      '@box/article/ArticleListed/ArticleListed'
    );

    ArticleListed.default();
  }
};

// Zámek článku
export const articleSubscription = async () => {
  const wrapper: HTMLDivElement | null = document.querySelector('[data-subscription]');

  if (wrapper) {
    const ArticleSubscription = await import(
      /* webpackChunkName: 'default/chunk-subscription' */
      '@box/article/ArticleSubscription'
    );

    ArticleSubscription.default();
  }
};

// GALERIE | Simple slider
export const smallGallery = async () => {
  const galleryElement: HTMLDivElement | null = document.querySelector('[data-small-gallery]');

  if (galleryElement) {
    const { default: SmallGallery } = await import(
      /* webpackChunkName: 'default/chunk-small-gallery' */
      '@features/gallery/SmallGallery'
    );

    SmallGallery(galleryElement);
  }
};

// Zobrazení a skrytí photo credit popisku
export const photoCreditToggle = async () => {
  const iconSelectors = [...document.querySelectorAll('[data-i-icon-photo-credit]')];

  if (iconSelectors.length > 0) {
    const PhotoCreditToggle = await import(
      /* webpackChunkName: 'default/chunk-photo-credit-toogle' */
      '@box/article/PhotoCreditToggle'
    );

    iconSelectors.forEach((iconSelector) => {
      if (iconSelector instanceof HTMLDivElement) {
        PhotoCreditToggle.default(iconSelector);
      }
    });
  }
};

// Kliknutí na ikonu + otevření nového okna
export const socialClick = async () => {
  const socialShareElements: NodeListOf<HTMLElement> = document.querySelectorAll(
    '[data-social-action="share"]'
  );

  if (socialShareElements && socialShareElements.length) {
    const { socialClick: init } = await import(
      /* webpackChunkName: 'default/chunk-social-click' */
      '@features/socialClick'
    );
    init(socialShareElements);
  }
};

// Obalení tabulky pro scrollovaní FEG-722
export const scrollForTable = async () => {
  const dataBrandDiv: HTMLDivElement | null = document.querySelector('#dataBrand');
  if (!dataBrandDiv) return;
  const tables = dataBrandDiv.querySelectorAll('table');

  if (tables && tables.length) {
    const { scrollableTables } = await import(
      /* webpackChunkName: 'default/chunk-table' */
      '@utils/table'
    );

    scrollableTables(tables);
  }
};
//ulozit a restorovat scroll pozici pri otevreni img in art
export const galleryInArtScrollPreserver = async () => {
  const articleId = getArticleId();

  if (!articleId) return; //nema smysl ani dělat další query selector když víme že není id
  const a = document.querySelectorAll('.article-image .img-in-art-gallery-link');

  if (!a || !a.length) return; //nemá smysl pokračovat když nejsou žádné imgs in art

  const { galleryInArtPreserveScroll } = await import(
    /* webpackChunkName: 'default/gallery-in-art-preserve-scroll' */
    '@artobj/ImageInArt'
  );
  galleryInArtPreserveScroll(a, articleId);
};

// Zobrazení buttonu a flash message přenačtení online reportu FEG-681
export const onlineReportRefresh = async () => {
  const onlineReports: NodeListOf<HTMLElement> =
    document.querySelectorAll('[data-online-report-id]');

  if (onlineReports.length) {
    const OnlineReportRefresh = await import(
      /* webpackChunkName: 'default/chunk-online-reports' */
      '@box/onlineReport/OnlineReportRefresh'
    );

    OnlineReportRefresh.default(onlineReports)
      .then(() => {
        /* Po načtení dat s nimi nic neděláme */
      })
      .catch((err) => {
        if (err instanceof Error) {
          Sentry.captureException(err);
          throw new Error(err.message);
        } else {
          throw new Error('Nečekaný error v načítání online přenosu v rámci bundle inicializace');
        }
      });
  }
};
